import { buildAction } from 'store/actions/actionCreator'

import { POST_BUG_REPORT, POST_BUG_REPORT_ERROR, POST_BUG_REPORT_SUCCESS } from './constants'

export const postBugReport = buildAction(POST_BUG_REPORT, 'payload')
export const postBugReportError = buildAction(POST_BUG_REPORT_ERROR, 'payload')
export const postBugReportSuccess = buildAction(POST_BUG_REPORT_SUCCESS, 'payload')
